import { createContext, useContext } from 'react';

export const IsMobileContext = createContext(false);

const useIsMobile = (): boolean => useContext(IsMobileContext);

export default useIsMobile;
